import React, { useState, useEffect, useCallback } from 'react';
import BannerBanksPage from '../../components/banks/BannerBanksPage';
import ContainerBanksPage from '../../components/banks/ContainerBanksPage';
import { useAxiosInterceptor } from '../../api/wrappers';
import { Bank } from '../../api/apiTypes';
import { fetchBanks, createBank, initializeDocumentClasses } from '../../api/functionApi';

const BanksPage = () => {
  useAxiosInterceptor();

  const [listaBanks, setListaBanks] = useState<Bank[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // 🔹 Carica lista banche
  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const banks = await fetchBanks();
    //  console.log('✅ Banche caricate:', banks);
      setListaBanks(banks);
    } catch (err: any) {
      console.error('❌ Errore nel caricamento delle banche:', err);
      setError('Si è verificato un errore durante il caricamento delle banche.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // 🔹 Aggiungi una banca e inizializza document classes
  const addBank = useCallback(async (name: string) => {
    try {
      const newBank = await createBank(name);
      setListaBanks((prev) => [...prev, newBank]);
  //    console.log('✅ Nuova banca creata:', newBank);

      // Inizializza document classes
      await initializeDocumentClasses(newBank.id);
 //     console.log(`✅ Document classes inizializzate per banca ${newBank.id}`);
    } catch (err: any) {
      console.error('❌ Errore nella creazione o inizializzazione della banca:', err);
      setError('Errore durante la creazione banca o inizializzazione document classes.');
    }
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-gray-50">
      <BannerBanksPage />
      <div className="px-8 lg:px-16 py-8">
        {error && (
          <div className="bg-red-100 text-red-700 border border-red-400 p-3 rounded mb-4">
            <strong>Errore:</strong> {error}
          </div>
        )}
        <ContainerBanksPage banks={listaBanks} addBank={addBank} />
      </div>
    </div>
  );
};

export default BanksPage;

